define('features/overlayGameLauncher/adventureTwo/shop/shopInit',[],function () {

    var QUERY_URL = 'thenewadventureprototype/gamification/shop/';

    return function AdventureTwoShopInit (Query,
                                          adventureTwoObservableData) {
        var self = this;

        self.init = function (player) {
            Query.fromRelativeCommonPath(QUERY_URL + player.id).get().then(function (data) {
                adventureTwoObservableData.property('shop')({
                    playerId: player.id,
                    items: data.items
                });
            });
        };
    };

});

